import { render, staticRenderFns } from "./insureNoticesTags.vue?vue&type=template&id=0198ef4a&scoped=true&"
import script from "./insureNoticesTags.vue?vue&type=script&lang=js&"
export * from "./insureNoticesTags.vue?vue&type=script&lang=js&"
import style0 from "./insureNoticesTags.vue?vue&type=style&index=0&id=0198ef4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0198ef4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0198ef4a')) {
      api.createRecord('0198ef4a', component.options)
    } else {
      api.reload('0198ef4a', component.options)
    }
    module.hot.accept("./insureNoticesTags.vue?vue&type=template&id=0198ef4a&scoped=true&", function () {
      api.rerender('0198ef4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insuranceCenter/components/insureNoticesTags.vue"
export default component.exports